import { SxProps } from '@mui/material';
import { IProductDataTransformed } from 'queries/products/useProductsList/types';

export interface IProductRowProps extends IProductDataTransformed {
  sx?: SxProps;
  index: number;
}

export interface ITableCell {
  cell: JSX.Element;
}

export interface IFormattedNumberConfig {
  minimumFractionDigits: number;
  maximumFractionDigits: number;
  style: 'percent';
}

export const formattedPercentConfig: IFormattedNumberConfig = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  style: 'percent',
};
